import axios from '@axios'

export default {
  namespaced: true,
  state: {
    event: {
      data: {},
      organizer: {},
    },

    calendarOptions: [
      {
        color: 'secondary',
        label: 'Private',
      },
      {
        color: 'info',
        label: 'Service',
      },
    ],
    selectedCalendars: ['Private', 'Service'],

    // API: { data: [{ id, slug }, ...] }
    eventTypes: [],
    selectedEventTypes: [], // for sidebar filtering (slugs)
  },

  getters: {
    event: state => state.event,
    eventData: state => state.event.data,
    eventOrganizer: state => state.event.organizer,
    eventTypes: state => state.eventTypes,
  },

  mutations: {
    SET_SELECTED_EVENTS(state, val) {
      state.selectedCalendars = val
    },

    setData(state, data) {
      state.event.data = data
    },

    setOrganizer(state, organizer) {
      state.event.organizer = organizer
    },

    SET_EVENT_TYPES(state, types) {
      state.eventTypes = types || []
      // by default select all types (slugs)
      state.selectedEventTypes = state.eventTypes.map(t => t.slug)
    },

    SET_SELECTED_EVENT_TYPES(state, slugs) {
      state.selectedEventTypes = slugs
    },

    DELETE_CALENDAR_DATA(state) {
      state.event = {
        data: {},
        organizer: {},
      }
      state.calendarOptions = [
        {
          color: 'secondary',
          label: 'Private',
        },
        {
          color: 'info',
          label: 'Service',
        },
      ]
      state.selectedCalendars = ['Private', 'Service']
    },
  },

  actions: {
    // ---- Event types ------------------------------------------------------
    fetchEventTypes({ commit }) {
      return axios
        .get('/event-types')
        .then(res => {
          const types = res.data.data || []
          commit('SET_EVENT_TYPES', types)
          return types
        })
    },

    // ---- Single event -----------------------------------------------------
    fetchEvent(ctx, data) {
      return axios
        .get(`/events/${data.eventId}`, { params: data.queryParams })
        .then(response => {
          const e = response.data?.data ?? response.data

          const existingExt = e.extendedProps ?? {}

          return {
            ...e,
            extendedProps: {
              ...existingExt,
              calendar: existingExt.calendar ?? null,
              type_id: existingExt.type_id ?? null,
              type_slug: existingExt.type_slug ?? null,
              organizer:e.organizer ?? {}
            },
          }
        })
    },

    // ---- Events list ------------------------------------------------------
    fetchEvents(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/events', { params: queryParams })
          .then(response => {
            const rawEvents = response.data.data || []

            const data = rawEvents
              .filter(event => queryParams.calendars.includes(event.extendedProps.calendar))
              .map(e => {
                const ext = e.extendedProps || {}

                return {
                  ...e,
                  extendedProps: {
                    ...ext,
                    // ✅ Trust backend extendedProps
                    type_id: ext.type_id ?? null,
                    type_slug: ext.type_slug ?? null,
                  },
                }
              })

            resolve({ data })
          })
          .catch(error => reject(error))
      })
    },

    // ---- Mutations to backend --------------------------------------------
    addEvent(ctx, { data }) {
      return new Promise((resolve, reject) => {
        axios
          .post('/events', { data })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    updateEvent(ctx, { data }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/events/${data.id}`, { data })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    removeEvent(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/events/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
